export const SITE_URL = "https://veteranspwc.com";
export const PHONE = "(321) 376-8744";
export const TEL = "tel:+13213768744";
export const SMS = "sms:+13213768744";
export const EMAIL = "info@veteranspwc.com";
export const MAILTO = `mailto:${EMAIL}`;
export const LOCATION = "Orlando, Florida";

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Residential", to: "/residential" },
  { label: "Commercial", to: "/commercial" },
  { label: "Before & After", to: "/before-after" },
  { label: "About", to: "/about" },
  { label: "Reviews", to: "/reviews" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const GALLERY_CATEGORIES = [
  "All", "Residential", "Commercial", "Driveways", "Concrete",
  "Pool Areas", "Pavers", "Soft Washing", "High-Pressure Washing",
];

export const LEAD_STATUSES = [
  "New Lead", "Qualified Residential Lead", "Qualified Commercial Lead",
  "Quote Requested", "Callback Requested", "Needs Human Review",
  "Existing Customer", "Outside Confirmed Service Area", "Spam", "Won", "Lost",
];

export const FINANCING_STATUSES = [
  "Not Offered", "Financing Discussed", "Link Sent", "Application Started",
  "Application Submitted", "Pending", "Approved", "Declined",
  "Customer Did Not Continue", "Funded", "Cancelled", "Needs Review",
];

export const CUSTOMER_STATUSES = [
  "Prospect", "Active Lead", "Quote Pending", "Quote Sent", "Follow-Up Needed",
  "Scheduled", "Active Customer", "Job In Progress", "Completed Customer",
  "Repeat Customer", "Lost", "Do Not Contact", "Archived",
];

export const QUOTE_STATUSES = [
  "Draft", "Sent", "Viewed", "Approved", "Declined", "Expired", "Revised",
];

export const JOB_STATUSES = [
  "Unscheduled", "Scheduled", "In Progress", "Completed", "On Hold", "Cancelled",
];

export const TASK_PRIORITIES = ["High", "Medium", "Low"];
export const TASK_TYPES = [
  "General Task", "Call Back", "Send Quote", "Follow-Up", "Site Visit",
  "Collect Payment", "Request Review", "Reminder",
];
export const TASK_STATUSES = ["Open", "In Progress", "Completed", "Cancelled"];

export const INVOICE_STATUSES = ["Draft", "Ready to Send", "Sent", "Delivered", "Viewed",
  "Billing Information Submitted", "Payment Pending", "Partially Paid", "Paid",
  "Overdue", "Disputed", "Cancelled", "Voided", "Refunded", "Partially Refunded", "Needs Review"];

export const PAYMENT_METHODS = ["Cash", "Check", "Credit card (virtual terminal)", "ACH",
  "Bank transfer", "Financing proceeds", "Other"];

export const PAYMENT_STATUSES = ["Pending", "Authorized", "Processing", "Approved", "Declined",
  "Failed", "Voided", "Refunded", "Partially Refunded", "Needs Review"];
